export const PUSH_NOTIFICATION_POPUP = {
  CONTENT:
    'Wil je een melding ontvangen als er nieuws is over je <b>favoriete radioshow</b> of als er een <b>gloednieuwe podcast</b> voor je klaarstaat?',
  CLOSE_BUTTON_TEXT: 'Nu liever niet',
  SUBSCRIBE_BUTTON_TEXT: 'Ja, graag!',
  SLIDE_IN_DELAY: 5000,
  LOCAL_STORAGE_NAME: 'JUKE_PUSH_NOTIFICATION_SHOWN',
};

export const PUSH_NOTIFICATION_POPUP_TEST_ID = {
  NOTIFICATION_POPUP: 'notificationPopup',
  CLOSE_BUTTON: 'closeButton',
  CLOSE_ICON: 'closeIcon',
  SUBSCRIBE_BUTTON: 'subscribeButton',
};
